
import React from 'react';
import { Button } from '../../../components/base/Button';

export const ProcessSection: React.FC = () => {
  const steps = [
    {
      number: '01',
      title: 'Agende pelo WhatsApp',
      description: 'Atendimento rápido e personalizado para entender suas necessidades específicas.',
      icon: 'ri-whatsapp-line'
    },
    {
      number: '02',
      title: 'Diagnóstico do Veículo',
      description: 'Avaliação completa e sugestão do melhor pacote para seu veículo.',
      icon: 'ri-search-eye-line'
    },
    {
      number: '03',
      title: 'Execução Premium',
      description: 'Entrega impecável com orientações de cuidado para manter a qualidade.',
      icon: 'ri-award-line'
    }
  ];

  const handleWhatsApp = () => {
    window.open('https://wa.me/554888397243?text=Olá! Gostaria de agendar uma avaliação para meu veículo.', '_blank');
  };

  return (
    <section className="py-20 bg-[#0D0D0D]">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center max-w-7xl mx-auto">
          {/* Left Side - Process Steps */}
          <div>
            <h2 className="text-4xl md:text-5xl font-montserrat font-bold text-white mb-8 tracking-wide">
              PROCESSO EM
              <span className="block text-[#C8A45D] mt-2">3 PASSOS</span>
            </h2>
            
            <p className="text-xl text-gray-300 font-open-sans mb-12 leading-relaxed">
              Um processo simples e eficiente para garantir o melhor resultado para seu veículo
            </p>

            <div className="space-y-8">
              {steps.map((step, index) => (
                <div key={index} className="flex items-start group">
                  {/* Step Number */}
                  <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-[#C8A45D] to-[#D4B76A] rounded-full flex items-center justify-center mr-6 group-hover:scale-110 transition-transform duration-300">
                    <span className="text-black font-montserrat font-bold text-lg">
                      {step.number}
                    </span>
                  </div>

                  {/* Step Content */}
                  <div className="flex-1">
                    <div className="flex items-center mb-3">
                      <i className={`${step.icon} text-[#C8A45D] text-xl mr-3`}></i>
                      <h3 className="text-xl font-montserrat font-bold text-white group-hover:text-[#C8A45D] transition-colors duration-300">
                        {step.title}
                      </h3>
                    </div>
                    <p className="text-gray-300 font-open-sans leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-12">
              <Button 
                onClick={handleWhatsApp}
                size="lg"
                icon="ri-whatsapp-line"
                className="text-lg px-10 py-4"
              >
                Iniciar Processo
              </Button>
            </div>
          </div>

          {/* Right Side - Professional Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden border-2 border-[#C8A45D]/30">
              <img 
                src="https://static.readdy.ai/image/23e6e82711d555609e11a3dec8506ccb/9d49c4941eb7dc9cd6dbd04da160105b.png"
                alt="Profissional da Aura trabalhando"
                className="w-full h-full object-cover object-top"
              />
              
              {/* Overlay with gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D]/80 via-transparent to-transparent"></div>
              
              {/* Quality Badge */}
              <div className="absolute bottom-6 left-6 bg-[#C8A45D] text-black px-4 py-2 rounded-full font-montserrat font-semibold">
                <i className="ri-award-line mr-2"></i>
                Qualidade Garantida
              </div>
            </div>

            {/* Floating Elements */}
            <div className="absolute -top-4 -right-4 w-8 h-8 bg-[#C8A45D] rounded-full opacity-60 animate-pulse"></div>
            <div className="absolute -bottom-4 -left-4 w-6 h-6 bg-[#C8A45D] rounded-full opacity-40 animate-pulse delay-1000"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
